/* eslint camelcase: 0 */

const content_width = 1152;

// ----- FONT, FONT-WEIGHT -----
const font = "'Source Sans Pro', 'Helvetica Neue', Helvetica, Arial, sans-serif";
const fw_bold = 700;
const fw_normal = 400;

// ----- COLORS -----

// ----- SIZES -----

const defaultTheme = {
  content_width,
  font,
  fw_bold,
  fw_normal,
};

export default defaultTheme;



// WEBPACK FOOTER //
// ./src/defaultTheme.js